import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { changeStatus, onFetchTypeUsers, onSetSelectedUser, selectUserState, setAction } from "../redux/slices/UserSlice"
import { UserAPI } from "../apis/UserAPI"
import { User } from "../types/slices/userType"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { UserTypeAPI } from "../apis/UserTypeAPI"

export const useUserStore = () => {

  const dispatch = useDispatch()
  const { users, typeUsers, userSelected, status, action } = useSelector(selectUserState)

  const userData = readLocalStorage(LocalStorageKey.USER_DATA)
  const idcompany = userData?.idcompany

  const getUsers = async (search = '') => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserAPI.getUsers({ search: search })
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
      const { detail } = response.data
      dispatch(changeStatus(ApiStatus.FETCHED))
      return detail;
    } catch (error) {
      console.log(error)
      return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const getUsersByCompany = async (search = '') => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserAPI.getUsersByCompany({ search: search, idcompany: idcompany })
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
      const { detail } = response.data
      dispatch(changeStatus(ApiStatus.FETCHED))
      return detail;
    } catch (error) {
      console.log(error)
      return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const createUser = async (data: any) => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserAPI.createUser(data)
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
      dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message || "");
      return true;
    } catch (error) {
      console.log(error)
      return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const createUserBySuperadmin = async (data: any) => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserAPI.createUserBySuperadmin(data)
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
      dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message || "");
      return true;
    } catch (error) {
      console.log(error)
      return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const editUser = async (iduser: number, data: any) => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserAPI.editUser(iduser, data)
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
      dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message || "");
      return true;
    } catch (error) {
      console.log(error)
      return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const deleteUser = async (iduser: number) => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserAPI.deleteUser(iduser)
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
      dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message || "");
      return true;
    } catch (error) {
      console.log(error)
      return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const getUserType = async (search = '') => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserTypeAPI.getUserType({ search: search })
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
      const { detail } = response.data
      dispatch(onFetchTypeUsers(detail))
      dispatch(changeStatus(ApiStatus.FETCHED))
      return detail;
    } catch (error) {
      console.log(error)
      return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const getPrivilege = async (search = '') => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserTypeAPI.getPrivilege({ search: search })
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
      const { detail } = response.data
      dispatch(changeStatus(ApiStatus.FETCHED))
      return detail;
    } catch (error) {
      console.log(error)
      return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const setSelectedUser = (user: User) => {
    try {
      dispatch(onSetSelectedUser(user))
    } catch (error) {
      console.log(error)
    }
  }

  const setActionUser = (state) => {
    try {
      dispatch(setAction(state))
    } catch (error) {
      console.log(error)
    }
  }

  const verifyPIN = async (data: object): Promise<boolean> => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserAPI.verifyPIN(data)
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");

        return false;
      }
      dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message || "");

      return true;
    } catch (error) {
      console.log(error)
      dispatch(changeStatus(ApiStatus.FETCHED))
      return false
    }
  }

  const changePassword = async (data: object): Promise<boolean> => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserAPI.changePassword(data)
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");

        return false;
      }
      dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message || "");

      return true;
    } catch (error) {
      console.log(error)
      dispatch(changeStatus(ApiStatus.FETCHED))
      return false
    }
  }

  const forgotPassword = async (data: object): Promise<boolean> => {
    try {
      dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserAPI.forgotPassword(data)
      if (!response?.status) {
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");

        return false;
      }
      dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message || "");

      return true;
    } catch (error) {
      console.log(error)
      dispatch(changeStatus(ApiStatus.FETCHED))
      return false
    }
  }

  return {
    //states
    users,
    typeUsers,
    userSelected,
    status,
    action,
    //actions
    getUsers,
    getUsersByCompany,
    getUserType,
    getPrivilege,
    createUser,
    createUserBySuperadmin,
    editUser,
    deleteUser,
    setSelectedUser,
    setActionUser,
    verifyPIN,
    changePassword,
    forgotPassword
  }
}